import React from 'react';
import {
  Card,
  Box,
  Typography,
  FormControlLabel,
  Switch,
  TextField,
  RadioGroup,
  Radio,
  FormLabel
} from '@mui/material';
import { getCurrencySymbol } from 'utils/valuePack/countryUtils';
import { DiscountTypes } from 'config/valuePackFormConfig';

const TierCard = ({
  tierType,
  tierData,
  onFieldChange,
  countryCurrency = 'USD',
  color = 'primary',
  duration = 1
}) => {
  // console.log("tierData in tier card : ", tierData);
  const calculateFinalPrice = () => {
    if (!tierData?.originalPrice) return 0;
    
    if (tierData.discountType === DiscountTypes.FLAT) {
      return Math.max(0, tierData.originalPrice - (tierData.flatDiscount || 0));
    } else {
      const discountAmount = (tierData.originalPrice * (tierData.percentageDiscount || 0)) / 100;
      return Math.max(0, tierData.originalPrice - discountAmount);
    }
  };

  const calculatePricePerMonth = () => {
    const finalPrice = calculateFinalPrice();
    if (!finalPrice || !duration || duration === 0) return 0;
    
    return Math.round(finalPrice / duration); // Round to whole number
  };

  const currencySymbol = getCurrencySymbol(countryCurrency);

  const formatPrice = (price) => {
    return Math.round(price).toLocaleString(); // Round and format with commas
  };

  return (
    <Card>
      <Box p={3}>
        <Typography variant="h6" gutterBottom color={color}>
          {tierType} Tier
        </Typography>
        
        <TextField
          fullWidth
          label="Tier Name"
          value={tierData?.name || ''}
          onChange={(e) => onFieldChange('name', e.target.value)}
          margin="normal"
          placeholder={`${tierType} Plan`}
        />

        <TextField
          fullWidth
          label="Description"
          value={tierData?.description || ''}
          onChange={(e) => onFieldChange('description', e.target.value)}
          margin="normal"
          multiline
          rows={3}
          placeholder={`Description for ${tierType} tier`}
        />

        <TextField
          fullWidth
          label={`Original Price (${currencySymbol})`}
          type="number"
          value={tierData?.originalPrice || ''}
          onChange={(e) => onFieldChange('originalPrice', parseFloat(e.target.value) || 0)}
          margin="normal"
          inputProps={{ min: 0, step: 1 }} // Allow only whole numbers
        />

        <Box mt={2}>
          <FormLabel component="legend">Discount Type</FormLabel>
          <RadioGroup
            row
            value={tierData?.discountType || 'flat'}
            onChange={(e) => onFieldChange('discountType', e.target.value)}
          >
            <FormControlLabel value="flat" control={<Radio />} label="Flat" />
            <FormControlLabel value="percentage" control={<Radio />} label="Percentage" />
          </RadioGroup>
        </Box>

        {tierData?.discountType === 'flat' ? (
          <TextField
            fullWidth
            label={`Flat Discount (${currencySymbol})`}
            type="number"
            value={tierData?.flatDiscount || ''}
            onChange={(e) => onFieldChange('flatDiscount', parseFloat(e.target.value) || 0)}
            margin="normal"
            inputProps={{ min: 0, step: 1 }} // Allow only whole numbers
          />
        ) : (
          <TextField
            fullWidth
            label="Percentage Discount (%)"
            type="number"
            value={tierData?.percentageDiscount || ''}
            onChange={(e) => onFieldChange('percentageDiscount', parseFloat(e.target.value) || 0)}
            margin="normal"
            inputProps={{ min: 0, max: 100, step: 1 }} // Allow only whole numbers
          />
        )}

        {/* Final Price Display */}
        <Box mt={2} p={2} bgcolor="grey.50" borderRadius={1}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>Final Price: {currencySymbol} {formatPrice(calculateFinalPrice())}</strong>
          </Typography>
          
          {/* Price Per Month Calculation */}
          {duration > 0 && (
            <>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                <strong>Price per month: {currencySymbol} {formatPrice(calculatePricePerMonth())}</strong>
              </Typography>
              <Typography variant="caption" color="textSecondary">
                For {duration} month{duration > 1 ? 's' : ''} duration
              </Typography>
            </>
          )}
          
          {tierData?.discountType === 'flat' && tierData?.flatDiscount > 0 && (
            <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
              (Original: {currencySymbol} {formatPrice(tierData.originalPrice)})
            </Typography>
          )}
          {tierData?.discountType === 'percentage' && tierData?.percentageDiscount > 0 && (
            <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
              (Original: {currencySymbol} {formatPrice(tierData.originalPrice)}, {tierData.percentageDiscount}% off)
            </Typography>
          )}
        </Box>

        <FormControlLabel
          control={
            <Switch
              checked={tierData?.isPopular || false}
              onChange={(e) => onFieldChange('isPopular', e.target.checked)}
              color="secondary"
            />
          }
          label="Mark as Popular"
          sx={{ mt: 2 }}
        />
      </Box>
    </Card>
  );
};

export default TierCard;

// import React from 'react';
// import {
//   Card,
//   Box,
//   Typography,
//   FormControlLabel,
//   Switch,
//   TextField,
//   RadioGroup,
//   Radio,
//   FormLabel
// } from '@mui/material';
// import { getCurrencySymbol } from 'utils/valuePack/countryUtils';
// import { DiscountTypes } from 'config/valuePackFormConfig';

// const TierCard = ({
//   tierType,
//   tierData,
//   onFieldChange,
//   countryCurrency = 'USD',
//   color = 'primary',
//   duration = 1 // Add duration prop
// }) => {
//   const calculateFinalPrice = () => {
//     if (!tierData?.originalPrice) return 0;
    
//     if (tierData.discountType === DiscountTypes.FLAT) {
//       return Math.max(0, tierData.originalPrice - (tierData.flatDiscount || 0));
//     } else {
//       const discountAmount = (tierData.originalPrice * (tierData.percentageDiscount || 0)) / 100;
//       return Math.max(0, tierData.originalPrice - discountAmount);
//     }
//   };

//   const calculatePricePerMonth = () => {
//     const finalPrice = calculateFinalPrice();
//     if (!finalPrice || !duration || duration === 0) return 0;
    
//     return (finalPrice / duration).toFixed(2);
//   };

//   const currencySymbol = getCurrencySymbol(countryCurrency);

//   return (
//     <Card>
//       <Box p={3}>
//         <Typography variant="h6" gutterBottom color={color}>
//           {tierType} Tier
//         </Typography>
        
//         <TextField
//           fullWidth
//           label="Tier Name"
//           value={tierData?.name || ''}
//           onChange={(e) => onFieldChange('name', e.target.value)}
//           margin="normal"
//           placeholder={`${tierType} Plan`}
//         />

//         <TextField
//           fullWidth
//           label="Description"
//           value={tierData?.description || ''}
//           onChange={(e) => onFieldChange('description', e.target.value)}
//           margin="normal"
//           multiline
//           rows={3}
//           placeholder={`Description for ${tierType} tier`}
//         />

//         <TextField
//           fullWidth
//           label={`Original Price (${currencySymbol})`}
//           type="number"
//           value={tierData?.originalPrice || ''}
//           onChange={(e) => onFieldChange('originalPrice', parseFloat(e.target.value) || 0)}
//           margin="normal"
//           inputProps={{ min: 0 }}
//         />

//         <Box mt={2}>
//           <FormLabel component="legend">Discount Type</FormLabel>
//           <RadioGroup
//             row
//             value={tierData?.discountType || 'flat'}
//             onChange={(e) => onFieldChange('discountType', e.target.value)}
//           >
//             <FormControlLabel value="flat" control={<Radio />} label="Flat" />
//             <FormControlLabel value="percentage" control={<Radio />} label="Percentage" />
//           </RadioGroup>
//         </Box>

//         {tierData?.discountType === 'flat' ? (
//           <TextField
//             fullWidth
//             label={`Flat Discount (${currencySymbol})`}
//             type="number"
//             value={tierData?.flatDiscount || ''}
//             onChange={(e) => onFieldChange('flatDiscount', parseFloat(e.target.value) || 0)}
//             margin="normal"
//             inputProps={{ min: 0 }}
//           />
//         ) : (
//           <TextField
//             fullWidth
//             label="Percentage Discount (%)"
//             type="number"
//             value={tierData?.percentageDiscount || ''}
//             onChange={(e) => onFieldChange('percentageDiscount', parseFloat(e.target.value) || 0)}
//             margin="normal"
//             inputProps={{ min: 0, max: 100 }}
//           />
//         )}

//         {/* Final Price Display */}
//         <Box mt={2} p={2} bgcolor="grey.50" borderRadius={1}>
//           <Typography variant="body2" color="textSecondary" gutterBottom>
//             <strong>Final Price: {currencySymbol} {calculateFinalPrice()}</strong>
//           </Typography>
          
//           {/* NEW: Price Per Month Calculation */}
//           {duration > 0 && (
//             <>
//               <Typography variant="body2" color="textSecondary" gutterBottom>
//                 <strong>Price per month: {currencySymbol} {calculatePricePerMonth()}</strong>
//               </Typography>
//               <Typography variant="caption" color="textSecondary">
//                 For {duration} month{duration > 1 ? 's' : ''} duration
//               </Typography>
//             </>
//           )}
          
//           {tierData?.discountType === 'flat' && tierData?.flatDiscount > 0 && (
//             <Typography variant="caption" color="textSecondary" display="block">
//               (Original: {currencySymbol} {tierData.originalPrice})
//             </Typography>
//           )}
//           {tierData?.discountType === 'percentage' && tierData?.percentageDiscount > 0 && (
//             <Typography variant="caption" color="textSecondary" display="block">
//               (Original: {currencySymbol} {tierData.originalPrice}, {tierData.percentageDiscount}% off)
//             </Typography>
//           )}
//         </Box>

//         <FormControlLabel
//           control={
//             <Switch
//               checked={tierData?.isPopular || false}
//               onChange={(e) => onFieldChange('isPopular', e.target.checked)}
//               color="secondary"
//             />
//           }
//           label="Mark as Popular"
//           sx={{ mt: 2 }}
//         />
//       </Box>
//     </Card>
//   );
// };

// export default TierCard;

// // import React from 'react';
// // import {
// //   Card,
// //   Box,
// //   Typography,
// //   FormControlLabel,
// //   Switch,
// //   TextField,
// //   RadioGroup,
// //   Radio,
// //   FormLabel
// // } from '@mui/material';
// // import { getCurrencySymbol } from 'utils/valuePack/countryUtils';
// // import { DiscountTypes } from 'config/valuePackFormConfig';

// // const TierCard = ({
// //   tierType,
// //   tierData,
// //   onFieldChange,
// //   countryCurrency = 'USD',
// //   color = 'primary'
// // }) => {
// //   const calculateFinalPrice = () => {
// //     // console.log("tier data in tier card : ", tierData);
// //     if (tierData.discountType === DiscountTypes.FLAT) {
// //       return Math.max(0, tierData.originalPrice - tierData.flatDiscount);
// //     } else {
// //       const discountAmount = (tierData.originalPrice * tierData.percentageDiscount) / 100;
// //       return Math.max(0, tierData.originalPrice - discountAmount);
// //     }
// //   };

// //   const currencySymbol = getCurrencySymbol(countryCurrency);

// //   return (
// //     <Card>
// //       <Box p={3}>
// //         <Typography variant="h6" gutterBottom color={color}>
// //           {tierType} Tier
// //         </Typography>
        
// //         <TextField
// //           fullWidth
// //           label="Tier Name"
// //           value={tierData.name}
// //           onChange={(e) => onFieldChange('name', e.target.value)}
// //           margin="normal"
// //           placeholder={`${tierType} Plan`}
// //         />

// //         <TextField
// //           fullWidth
// //           label="Description"
// //           value={tierData.description}
// //           onChange={(e) => onFieldChange('description', e.target.value)}
// //           margin="normal"
// //           multiline
// //           rows={3}
// //           placeholder={`Description for ${tierType} tier`}
// //         />

// //         <TextField
// //           fullWidth
// //           label={`Original Price (${currencySymbol})`}
// //           type="number"
// //           value={tierData.originalPrice}
// //           onChange={(e) => onFieldChange('originalPrice', parseFloat(e.target.value) || 0)}
// //           margin="normal"
// //           inputProps={{ min: 0 }}
// //         />

// //         <Box mt={2}>
// //           <FormLabel component="legend">Discount Type</FormLabel>
// //           <RadioGroup
// //             row
// //             value={tierData.discountType}
// //             onChange={(e) => onFieldChange('discountType', e.target.value)}
// //           >
// //             <FormControlLabel value="flat" control={<Radio />} label="Flat" />
// //             <FormControlLabel value="percentage" control={<Radio />} label="Percentage" />
// //           </RadioGroup>
// //         </Box>

// //         {tierData.discountType === 'flat' ? (
// //           <TextField
// //             fullWidth
// //             label={`Flat Discount (${currencySymbol})`}
// //             type="number"
// //             value={tierData.flatDiscount}
// //             onChange={(e) => onFieldChange('flatDiscount', parseFloat(e.target.value) || 0)}
// //             margin="normal"
// //             inputProps={{ min: 0 }}
// //           />
// //         ) : (
// //           <TextField
// //             fullWidth
// //             label="Percentage Discount (%)"
// //             type="number"
// //             value={tierData.percentageDiscount}
// //             onChange={(e) => onFieldChange('percentageDiscount', parseFloat(e.target.value) || 0)}
// //             margin="normal"
// //             inputProps={{ min: 0, max: 100 }}
// //           />
// //         )}

// //         <Box mt={2} p={2} bgcolor="grey.50" borderRadius={1}>
// //           <Typography variant="body2" color="textSecondary">
// //             <strong>Final Price: {currencySymbol} {calculateFinalPrice()}</strong>
// //           </Typography>
// //           {tierData.discountType === 'flat' && tierData.flatDiscount > 0 && (
// //             <Typography variant="caption" color="textSecondary">
// //               (Original: {currencySymbol} {tierData.originalPrice})
// //             </Typography>
// //           )}
// //           {tierData.discountType === 'percentage' && tierData.percentageDiscount > 0 && (
// //             <Typography variant="caption" color="textSecondary">
// //               (Original: {currencySymbol} {tierData.originalPrice}, {tierData.percentageDiscount}% off)
// //             </Typography>
// //           )}
// //         </Box>

// //         <FormControlLabel
// //           control={
// //             <Switch
// //               checked={tierData.isPopular}
// //               onChange={(e) => onFieldChange('isPopular', e.target.checked)}
// //               color="secondary"
// //             />
// //           }
// //           label="Mark as Popular"
// //           sx={{ mt: 2 }}
// //         />
// //       </Box>
// //     </Card>
// //   );
// // };

// // export default TierCard;
